import InternetExplorer from './InternetExplorer';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import PasswordsNotepad from './PasswordsNotepad';
import FakeExcel from './FakeExcel';
import DSAInternetExplorer from './DSAInternetExplorer';
import MSNMessenger from './MSNMessenger';
import OutlookExpress from './OutlookExpress';
import SecurityChecklist from './SecurityChecklist';
import SecurityCenter from './SecurityCenter';
import CommandPrompt from './CommandPrompt';
import WindowsUpdate from './WindowsUpdate';
import StickyNotes from './StickyNotes';
import ComplianceCalendar from './ComplianceCalendar';
import MyPictures from './MyPictures';
import HelpAndSupport from './HelpAndSupport';
import TaskManager from './TaskManager';
import Solitaire from './Solitaire';
import Testimonials from './Testimonials';
import Calculator from './Calculator';
import Pinball from './Pinball';
import RecycleBin from './RecycleBin';
import DisplayProperties from './DisplayProperties';
import MyDocuments from './MyDocuments';
import PrivacyTerms from './PrivacyTerms';
import WebDesign from './WebDesign';
import CyberAwareness from './CyberAwareness';

import iePaper from 'assets/windowsIcons/ie-paper.png';
import picturesSmall from 'assets/windowsIcons/307(32x32).png';
import helpSmall from 'assets/windowsIcons/747(16x16).png';
import ie from 'assets/windowsIcons/ie.png';
import mine from 'assets/minesweeper/mine-icon.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';
import msn from 'assets/windowsIcons/msn.png';
import mail from 'assets/windowsIcons/mail.png';
// Security Center = XP firewall icon
import firewallLarge from 'assets/windowsIcons/67(32x32).png';
import firewallSmall from 'assets/windowsIcons/897(16x16).png';
// Command Prompt = black terminal window
import cmdLarge from 'assets/windowsIcons/cmd-prompt.svg';
import cmdSmall from 'assets/windowsIcons/cmd-prompt.svg';
// Windows Update = shield icon (authentic XP Update icon)
import updateLarge from 'assets/windowsIcons/227(32x32).png';
import updateSmall from 'assets/windowsIcons/227(16x16).png';
// Calendar / Compliance
import calendarLarge from 'assets/windowsIcons/308(32x32).png';
import calendarSmall from 'assets/windowsIcons/308(16x16).png';
// Excel-style icon for My Finances
import excelLarge from 'assets/windowsIcons/excel-icon.svg';
import excelSmall from 'assets/windowsIcons/excel-icon.svg';
import solitaireIcon from 'assets/windowsIcons/solitaire.png';
import pinballIcon from 'assets/windowsIcons/pinball.png';
import recycleBinIcon from 'assets/windowsIcons/recycle-bin-empty.png';
import powerpointIcon from 'assets/windowsIcons/powerpoint.svg';

// Start with clean desktop — Help and Support opens via dispatch on mount
export const defaultAppState = [];

export const defaultIconState = [
  // --- Websites ---
  {
    id: 0,
    icon: ie,
    title: 'Dead Simple Computing',
    component: InternetExplorer,
    isFocus: false,
  },
  {
    id: 1,
    icon: ie,
    title: 'Dead Simple Accounting',
    component: DSAInternetExplorer,
    isFocus: false,
  },
  {
    id: 16,
    icon: ie,
    title: 'Web Design & Hosting',
    component: WebDesign,
    isFocus: false,
  },
  {
    id: 4,
    icon: mail,
    title: 'Outlook Express',
    component: OutlookExpress,
    isFocus: false,
  },
  // --- Documents ---
  {
    id: 7,
    icon: notepadLarge,
    title: 'Security Checklist.rtf',
    component: SecurityChecklist,
    isFocus: false,
  },
  {
    id: 8,
    icon: notepadLarge,
    title: 'passwords.txt',
    component: PasswordsNotepad,
    isFocus: false,
  },
  {
    id: 9,
    icon: excelLarge,
    title: 'My Finances.xls',
    component: FakeExcel,
    isFocus: false,
  },
  {
    id: 10,
    icon: notepadLarge,
    title: 'TAX DEADLINES.txt',
    component: StickyNotes,
    isFocus: false,
  },
  {
    id: 18,
    icon: powerpointIcon,
    title: 'Cyber Awareness 2004.ppt',
    component: CyberAwareness,
    isFocus: false,
  },
  // --- Tools ---
  {
    id: 2,
    icon: computerLarge,
    title: 'My Computer',
    component: MyComputer,
    isFocus: false,
  },
  {
    id: 11,
    icon: calendarLarge,
    title: 'Compliance Calendar',
    component: ComplianceCalendar,
    isFocus: false,
  },
  {
    id: 17,
    icon: winamp,
    title: 'Winamp',
    component: Winamp,
    isFocus: false,
  },
  {
    id: 15,
    icon: recycleBinIcon,
    title: 'Recycle Bin',
    component: RecycleBin,
    isFocus: false,
  },
];

export const appSettings = {
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'Dead Simple Computing - Internet Explorer',
    },
    component: InternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'DSA Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'Dead Simple Accounting - Internet Explorer',
    },
    component: DSAInternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 160,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: 'Minesweeper',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: 'Untitled - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'passwords.txt': {
    header: {
      icon: notepad,
      title: 'passwords.txt - Notepad',
    },
    component: PasswordsNotepad,
    defaultSize: {
      width: 500,
      height: 450,
    },
    defaultOffset: {
      x: 200,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'My Finances.xls': {
    header: {
      icon: excelSmall,
      title: 'My Finances.xls - Microsoft Excel',
    },
    component: FakeExcel,
    defaultSize: {
      width: 750,
      height: 500,
    },
    defaultOffset: {
      x: 100,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Winamp: {
    header: {
      icon: winamp,
      title: 'Winamp',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'MSN Messenger': {
    header: {
      icon: msn,
      title: 'MSN Messenger',
    },
    component: MSNMessenger,
    defaultSize: {
      width: 300,
      height: 450,
    },
    defaultOffset: {
      x: 200,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Outlook Express': {
    header: {
      icon: mail,
      title: 'New Message - Outlook Express',
    },
    component: OutlookExpress,
    defaultSize: {
      width: 600,
      height: 480,
    },
    defaultOffset: {
      x: 180,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Security Checklist': {
    header: {
      icon: notepad,
      title: 'Security Checklist.rtf - WordPad',
    },
    component: SecurityChecklist,
    defaultSize: {
      width: 700,
      height: 550,
    },
    defaultOffset: {
      x: 120,
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Security Center': {
    header: {
      icon: firewallSmall,
      title: 'Windows Security Center',
    },
    component: SecurityCenter,
    defaultSize: {
      width: 650,
      height: 520,
    },
    defaultOffset: {
      x: 130,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Command Prompt': {
    header: {
      icon: cmdSmall,
      title: 'C:\\WINDOWS\\system32\\cmd.exe',
    },
    component: CommandPrompt,
    defaultSize: {
      width: 680,
      height: 420,
    },
    defaultOffset: {
      x: 100,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Windows Update': {
    header: {
      icon: updateSmall,
      title: 'Windows Update',
    },
    component: WindowsUpdate,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 150,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Sticky Notes': {
    header: {
      icon: notepad,
      title: 'TAX DEADLINES.txt - Notepad',
    },
    component: StickyNotes,
    defaultSize: {
      width: 400,
      height: 500,
    },
    defaultOffset: {
      x: 250,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Compliance Calendar': {
    header: {
      icon: calendarSmall,
      title: 'Compliance Calendar',
    },
    component: ComplianceCalendar,
    defaultSize: {
      width: 650,
      height: 500,
    },
    defaultOffset: {
      x: 160,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'My Pictures': {
    header: {
      icon: picturesSmall,
      title: 'My Pictures',
    },
    component: MyPictures,
    defaultSize: {
      width: 650,
      height: 480,
    },
    defaultOffset: {
      x: 170,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Help and Support': {
    header: {
      icon: helpSmall,
      title: 'Help and Support Center',
    },
    component: HelpAndSupport,
    defaultSize: {
      width: 700,
      height: 520,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Task Manager': {
    header: {
      icon: computer,
      title: 'Windows Task Manager',
    },
    component: TaskManager,
    defaultSize: {
      width: 450,
      height: 500,
    },
    defaultOffset: {
      x: 200,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  // Solitaire — removed from the app
  // Solitaire: {
  //   header: {
  //     icon: solitaireIcon,
  //     title: 'Solitaire',
  //   },
  //   component: Solitaire,
  //   defaultSize: {
  //     width: 580,
  //     height: 450,
  //   },
  //   defaultOffset: {
  //     x: Math.min(100, window.innerWidth - 590),
  //     y: 20,
  //   },
  //   resizable: true,
  //   minimized: false,
  //   maximized: window.innerWidth < 800,
  //   multiInstance: false,
  // },
  'My Documents': {
    header: {
      icon: calendarSmall,
      title: 'My Documents',
    },
    component: MyDocuments,
    defaultSize: {
      width: 650,
      height: 400,
    },
    defaultOffset: {
      x: 140,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Testimonials: {
    header: {
      icon: notepad,
      title: 'Client Reviews - My Documents',
    },
    component: Testimonials,
    defaultSize: {
      width: 650,
      height: 480,
    },
    defaultOffset: {
      x: 160,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Calculator: {
    header: {
      icon: calendarSmall, // using small icon since no dedicated calc icon exists
      title: 'Calculator',
    },
    component: Calculator,
    defaultSize: {
      width: 260,
      height: 340,
    },
    defaultOffset: {
      x: Math.min(300, window.innerWidth - 270),
      y: Math.min(100, window.innerHeight - 370),
    },
    resizable: false,
    minimized: false,
    maximized: window.innerWidth < 400,
    multiInstance: false,
  },
  Pinball: {
    header: {
      icon: pinballIcon,
      title: '3D Pinball for Windows - Space Cadet',
    },
    component: Pinball,
    defaultSize: {
      width: 400,
      height: 550,
    },
    defaultOffset: {
      x: Math.min(200, window.innerWidth - 410),
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Recycle Bin': {
    header: {
      icon: recycleBinIcon,
      title: 'Recycle Bin',
    },
    component: RecycleBin,
    defaultSize: {
      width: 650,
      height: 400,
    },
    defaultOffset: {
      x: 180,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Display Properties': {
    header: {
      icon: computer,
      title: 'Display Properties',
    },
    component: DisplayProperties,
    defaultSize: {
      width: 400,
      height: 460,
    },
    defaultOffset: {
      x: Math.min(220, window.innerWidth - 410),
      y: 40,
    },
    resizable: false,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Privacy Policy': {
    header: {
      icon: helpSmall,
      title: 'Privacy Policy & Terms of Use',
    },
    component: PrivacyTerms,
    defaultSize: {
      width: 550,
      height: 500,
    },
    defaultOffset: {
      x: 180,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Web Design': {
    header: {
      icon: iePaper,
      title: 'Dead Simple Web Solutions - Internet Explorer',
    },
    component: WebDesign,
    defaultSize: {
      width: 750,
      height: 520,
    },
    defaultOffset: {
      x: Math.min(120, window.innerWidth - 760),
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Cyber Awareness': {
    header: {
      icon: powerpointIcon,
      title: 'Cyber Awareness Training 2004 - Microsoft PowerPoint',
    },
    component: CyberAwareness,
    defaultSize: {
      width: 850,
      height: 600,
    },
    defaultOffset: {
      x: Math.min(140, window.innerWidth - 760),
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
};

export {
  InternetExplorer, DSAInternetExplorer, Minesweeper, ErrorBox, MyComputer,
  Notepad, Winamp, PasswordsNotepad, FakeExcel,
  MSNMessenger, OutlookExpress, SecurityChecklist,
  SecurityCenter, CommandPrompt, WindowsUpdate,
  StickyNotes, ComplianceCalendar, MyPictures, HelpAndSupport,
  TaskManager, Solitaire, Testimonials,
  Calculator, Pinball, RecycleBin, DisplayProperties,
  MyDocuments, PrivacyTerms, WebDesign, CyberAwareness,
};
